import { Link } from 'react-router-dom';
import { Star, ArrowRight, User, Lock } from 'lucide-react';

// Contact info is deliberately never shown on the card — same as the app's handyman
// list, which shows name/trade/rating only. Reaching a fundi always goes through the
// gated "View Contact Details" button on their profile page.
const UserCard = ({ id, firstname, lastname, profession, profileImageUrl, rating }) => {
    const stars = Math.round(Number(rating) || 0);

    return (
        <Link
            to={`/find-fundi/shared/${id}`}
            className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg hover:border-brandgreen transition-all duration-300 flex flex-col items-center text-center p-8 h-full"
        >
            {profileImageUrl ? (
                <img
                    src={profileImageUrl}
                    alt={firstname && lastname ? `${firstname} ${lastname}` : 'Profile'}
                    className="h-24 w-24 rounded-full object-cover bg-gray-50 ring-4 ring-brandgreen/10 mb-5"
                />
            ) : (
                <div className="h-24 w-24 rounded-full bg-navy flex items-center justify-center mb-5">
                    <User className="w-10 h-10 text-white" />
                </div>
            )}

            {firstname && lastname ? (
                <h3 className="capitalize font-bold text-lg text-navy mb-2">{`${firstname} ${lastname}`}</h3>
            ) : (
                <div className="h-4 bg-gray-200 rounded-full w-40 mb-3 animate-pulse"></div>
            )}

            {profession ? (
                <span className="text-xs bg-brandgreen/10 text-brandgreen py-1.5 px-3 rounded-full font-semibold mb-3">
                    {profession}
                </span>
            ) : (
                <div className="h-4 bg-gray-200 rounded-full w-32 mb-3 animate-pulse"></div>
            )}

            <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                    <Star
                        key={i}
                        className={`w-4 h-4 ${i < stars ? 'text-brandgreen fill-current' : 'text-gray-300'}`}
                    />
                ))}
            </div>

            <div className="w-full border-t border-gray-100 pt-4 text-sm text-gray-500">
                <div className="flex items-center justify-center gap-2">
                    <Lock className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
                    <span>Contact details protected</span>
                </div>
            </div>

            <span className="mt-auto pt-5 inline-flex items-center text-brandgreen font-semibold text-sm">
                View Portfolio
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
            </span>
        </Link>
    );
}

export default UserCard;
